import { getObjectUtil } from 'packages/src'
import { START_WORKOUT_PATH } from '../../constants'
import { createSelector } from 'reselect'

const getCurrentWorkoutSectionIndexStartWorkoutSelect = createSelector(
  state => getObjectUtil(state, START_WORKOUT_PATH.CURRENT_WORKOUT_SECTION_INDEX),
  (currentWorkoutSectionIndex) => currentWorkoutSectionIndex
)

export default getCurrentWorkoutSectionIndexStartWorkoutSelect
